/*
  Tapticle motion — scroll-reveal for [data-tt-animate].
  Vanilla, deferred, no dependencies. Fully inert when the user prefers
  reduced motion (the matching CSS is also gated behind the same media
  query and an html.tt-motion class, so content is never hidden if this
  file fails to run).
*/
(() => {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  document.documentElement.classList.add('tt-motion');

  // Auto-stagger: any [data-tt-animate] inside a [data-tt-stagger] that
  // hasn't been given an explicit --tt-animate-delay gets one derived from
  // its index among the group's animated descendants. Inline delays
  // (set in Liquid) always win, so this is backwards-compatible.
  const STAGGER_STEP = 80; // ms
  const applyStagger = () => {
    document.querySelectorAll('[data-tt-stagger]').forEach((group) => {
      const step = parseInt(group.dataset.ttStagger, 10) || STAGGER_STEP;
      const items = group.querySelectorAll('[data-tt-animate]');
      items.forEach((el, i) => {
        if (!el.style.getPropertyValue('--tt-animate-delay')) {
          el.style.setProperty('--tt-animate-delay', i * step + 'ms');
        }
      });
    });
  };

  const reveal = () => {
    applyStagger();
    const targets = document.querySelectorAll('[data-tt-animate]:not(.tt-in-view)');
    if (!targets.length) return;

    const io = new IntersectionObserver(
      (entries, observer) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          entry.target.classList.add('tt-in-view');
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );

    targets.forEach((el) => io.observe(el));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reveal, { once: true });
  } else {
    reveal();
  }

  // Re-run when the theme editor re-renders a section.
  document.addEventListener('shopify:section:load', reveal);
})();
